import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/site/Header";
import { Hero } from "./components/site/Hero";
import { LogisticsStrip } from "./components/site/LogisticsStrip";
import { CourseBanner } from "./components/site/CourseBanner";
import { Marquee } from "./components/site/Marquee";
import { Services } from "./components/site/Services";
import { WhyVans } from "./components/site/WhyVans";
import { CrossBorder } from "./components/site/CrossBorder";
import { Industries } from "./components/site/Industries";
import { Visibility } from "./components/site/Visibility";
import { About } from "./components/site/About";
import { QuoteSection } from "./components/site/QuoteSection";
import { FAQ } from "./components/site/FAQ";
import { FinalCTA } from "./components/site/FinalCTA";
import { Footer } from "./components/site/Footer";
import { NotFound } from "./components/site/NotFound";
import { InquiryModal } from "./components/site/InquiryModal";

function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <LogisticsStrip />
        <CourseBanner />
        <Marquee />
        <Services />
        <WhyVans />
        <CrossBorder />
        <Industries />
        <Visibility />
        <About />
        <QuoteSection />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </>
  );
}

function App() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => { lenis.raf(time); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);

    // Pause smooth scroll while any Radix dialog/modal is open so the
    // background page doesn't move and the modal scrolls natively.
    const syncLenisWithModals = () => {
      const modalOpen = document.querySelector('[role="dialog"][data-state="open"]');
      if (modalOpen) lenis.stop();
      else lenis.start();
    };
    const observer = new MutationObserver(syncLenisWithModals);
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["data-state"] });

    return () => { cancelAnimationFrame(raf); observer.disconnect(); lenis.destroy(); window.__lenis = null; };
  }, []);

  return (
    <div className="App min-h-screen bg-white">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
      <InquiryModal />
    </div>
  );
}

export default App;
